import React from 'react';
import CommonModal from './CommonModal';
import CustomButton from '../CustomButton';
import { Grid, Typography } from '@mui/material';

const SuccessModal = ({ Succesopen, SuccessetOpen }: { Succesopen: any; SuccessetOpen: any }) => {
  return (
    <CommonModal
      onClose={() => SuccessetOpen(false)}
      open={Succesopen}
      modalClassName='px-20 py-20'
      boxProps={{ width: 300, height: 150 }}
    >
      <Grid>
        <Typography textAlign={'center'} mb={5}>
         Successfully deleted
        </Typography>
      </Grid>
      <Grid display={"flex"}justifyContent={"center"}>
      <CustomButton
          text={'ok'}
          className='px-5 py-3'
          color={'warning'}
          onClick={() => SuccessetOpen(false)}
        />
        </Grid>
      
    </CommonModal>
  );
};

export default SuccessModal;
